import angular from 'angular';
import skeleton from './skeleton';

export default angular
  .module('components.skeleton', [])
  .component('skeleton', skeleton).name;
